<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales Details Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      total_amount: 0,
      total_paid: 0,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Sales Details Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Details Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QUANTITY',
        },
        {
          key: "SPrice_no",
          sortable: true,
          label: 'UNIT PRICE',
        },
        {
          key: "total_price",
          sortable: true,
          label: 'TOTAL PRICE',
        },
        {
          key: "sale.sale_date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        }
      ],
      json_fields: {
        PRODUCT: "product",
        QUANTITY: "qty",
        UNIT_PRICE: "SPrice",
        TOTAL: "total_priceno",
        DATE: "sale.sale_date",
        RECEIPT: "receipt",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      details: {
            saledata: this.$route.params.date,
            period: this.$route.params.period,
          },
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("sales", ["SaleDetails"]),
    ...mapGetters("auth", ["business","branch"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.SaleDetails ? this.SaleDetails.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.SaleDetails ? this.SaleDetails.length : 1;
  },  
  methods: {
    ...mapActions({      
        fetchSalesDetails: "sales/fetchSalesDetails",
        FetchGeneralSettings: "setting/fetchGeneralSettings", 
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  updated() {
    let total_amount = 0;
      // let total_paid = 0;
      if(this.SaleDetails){
        this.SaleDetails.forEach((item)=>{
          total_amount = total_amount+parseInt(item.total_priceno);
        });
        this.total_amount = total_amount;
      }
  },
  watch: {
    SaleDetails(newValue){
        if(newValue == true){
        this.fetchSalesDetails(this.details);
        }
    }
  },
  created() {
    this.fetchSalesDetails(this.details);
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Sales Details Report</h3>
              </div>
              <div class="col-md-3" align="right">
                  <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
              </div>
            </div>            
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info mt-4"
                  :data="SaleDetails"
                  :fields="json_fields"
                  :worksheet="'SALE DETAILS REPORT EXPORTED ON' + currentdate"
                  type="csv"
                  :name="'Saledetails_export' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="SaleDetails?SaleDetails:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>           
              </b-table>
              <div class="row">
                  <div class="col-md-4"></div>
                  <div class="col-md-4">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeperator(total_amount)}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!SaleDetails"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
